import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import JobSearch from "@sourceflow-uk/job-search";
import imageMetaData from "../../.sourceflow/image_metadata.json";
import { Container, Row, Col } from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";
import Arrow from "/public/site-assets/svg/arrow.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";
import md5 from "md5";
import Helmet from 'react-helmet'

export default function MainBanner({
    global,
    pathPrefix,
    customClass = "",
    content,
    imageURL1,
    imageURL2,
    imageALT1,
    imageALT2,
    jobSearch = false,
    displayImage1 = true,
    pageAnchor = false,
    editableContent = true,
    locale = "https://www.bartechstaffing.com",
    buttonLink = false,
    buttonTitle,
    post,
    buttonLink2,
    buttonTitle2,
    ctaLink = null,
    ctaTitle = null,
}) {
    return (
        <section
            className={`${styles.root} ${customClass} position-relative ${displayImage1 ? null : "hidden-image-1"
                }`}
        >
            <Helmet>
                {imageURL2 && <link rel="prefetch" href={imageURL2} />}
            </Helmet>
            <Container>
                <Row className={`m-0 justify-content-between`}>
                    <Col
                        lg={6}
                        className="contentWrapper d-flex flex-wrap align-items-center position-relative"
                    >
                        <div>
                            {buttonLink && (
                                <Link href={buttonLink}>
                                    <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4"><strong>{buttonTitle}</strong></a>
                                </Link>
                            )}

                            <div className="d-flex justify-content-between mb-4 align-items-center">

                                <div>
                                    {post?.tag?.map((post, index) =>
                                        <span className="tag me-1" key={index}>{post}</span>
                                    )}
                                </div>
                            </div>
                            {editableContent ? (
                                <SourceFlowText
                                    global={global}
                                    path={`${pathPrefix}.content`}
                                    type="html"
                                >
                                    {content}
                                </SourceFlowText>
                            ) : (
                                content
                            )}
                            {post.banner_subtitle && (
                                <div className="mt-4">{post.banner_subtitle}</div>
                            )}
                            {ctaLink && ctaTitle &&
                                <a href={ctaLink} className="secondaryBtn no-arrow mt-3 mb-0" rel="noopener noreferrer">
                                    {ctaTitle}
                                </a>
                            }
                            {jobSearch ? (
                                <JobSearch
                                    options={{
                                        searchResults: false,
                                        searchFilters: false,
                                        submitDestination: `${locale ? locale : ""}/jobs`,
                                    }}
                                    translations={{
                                        "input.placeHolder": "Job Title or Keyword",
                                    }}
                                />
                            ) : null}
                        </div>
                    </Col>
                    {buttonLink2 && (
                        <div className="position-relative z-1 w-auto d-flex align-items-end secondary-button mb-5 mb-lg-0 px-0">
                            <a className="primaryBtn no-arrow m-0" href={buttonLink2}>{buttonTitle2}</a>
                        </div>
                    )}
                    {displayImage1 ? (
                        <Col lg={6} className="position-relative mainImageWrapper">
                            <SourceFlowImage
                                src={
                                    imageURL1
                                        ? imageURL1
                                        : "/site-assets/placeholders/img-placeholder.jpg"
                                }
                                path={`${pathPrefix ? pathPrefix : md5(imageURL1)}.image`}
                                imagesMetaData={imageMetaData}
                                size="413x448"
                                alt={imageALT1}
                                className="d-none d-md-block card-img rounded-4"
                                loading={"eager"}
                            />
                        </Col>
                    ) : null}
                    <div className="imageWrapper position-absolute p-0">
                        <SourceFlowImage
                            src={
                                imageURL2
                                    ? imageURL2
                                    : "/site-assets/placeholders/img-placeholder.jpg"
                            }
                            imagesMetaData={imageMetaData}
                            path={`${pathPrefix ? pathPrefix : md5(imageURL2)}.image`}
                            size="2000x"
                            alt={imageALT2}
                            className="card-img rounded-0"
                            loading={"eager"}
                        />
                    </div>
                </Row>
                {pageAnchor ? (
                    <AnchorLink
                        offset="80"
                        href={`#${pageAnchor}`}
                        className="banner-anchor position-absolute"
                        aria-label="Scroll Bottom"
                    >
                        <Arrow />
                    </AnchorLink>
                ) : null}
            </Container>
        </section>
    );
}
